export default "__VITE_ASSET__RKlTyQMb__"